import { render, staticRenderFns } from "./Model3D.vue?vue&type=template&id=5218ed29&scoped=true&"
import script from "./Model3D.vue?vue&type=script&lang=js&"
export * from "./Model3D.vue?vue&type=script&lang=js&"
import style0 from "./Model3D.vue?vue&type=style&index=0&id=5218ed29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218ed29",
  null
  
)

export default component.exports